import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const apiErr = (e) => toast.error(formatApiError(e.response?.data?.detail) || "Something went wrong");
